
import UsersStatCard from "./UsersStatCard";
import CampaignsStatCard from "./CampaignsStatCard";
import SuccessTransactionStatCard from "./SuccessTransactionStatCard";

export default function FakeDashboard() {
 

  return (
    <div className="flex flex-col gap-5 @container 2xl:gap-x-6 2xl:gap-y-7 3xl:gap-8">
      <p className="text-xl font-semibold">Users</p>
      <UsersStatCard />

      <p className="text-xl font-semibold">Campaigns</p>
      <CampaignsStatCard  />

      <p className="text-xl font-semibold">Transactions (Success)</p>
      <SuccessTransactionStatCard
       
      />
     

    
    </div>
  );
}
